module.exports = __webpack_public_path__ + "media/hyper/fonts/materialdesignicons-webfont-d9f39587ab2751b33bcfe788c891d1cc.woff2";